import { SERVICE_RADIUS_KM_MAX, SERVICE_RADIUS_KM_MIN } from "@shared/types";

/**
 * A typed service radius: null when blank, the km figure when it is a whole
 * number from 1 to 500, and NaN otherwise so a caller can refuse it.
 */
export function parseServiceRadius(value: string): number | null {
	const trimmed = value.trim();
	if (!trimmed) return null;
	const km = Number(trimmed);
	return Number.isInteger(km) &&
		km >= SERVICE_RADIUS_KM_MIN &&
		km <= SERVICE_RADIUS_KM_MAX
		? km
		: Number.NaN;
}
